// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/Quicksand-Medium/fonts/Quicksand-Medium.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/Quicksand-Medium/fonts/Quicksand-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./fonts/Quicksand-Medium/fonts/Quicksand-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./fonts/Quicksand-Medium/fonts/Quicksand-Medium.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./fonts/Quicksand-Regular/fonts/Quicksand-Regular.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./fonts/Quicksand-Regular/fonts/Quicksand-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./fonts/Quicksand-Regular/fonts/Quicksand-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./fonts/Quicksand-Regular/fonts/Quicksand-Regular.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./fonts/Quicksand-SemiBold/fonts/Quicksand-SemiBold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("./fonts/Quicksand-SemiBold/fonts/Quicksand-SemiBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("./fonts/Quicksand-SemiBold/fonts/Quicksand-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("./fonts/Quicksand-SemiBold/fonts/Quicksand-SemiBold.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("./fonts/Quicksand-Bold/fonts/Quicksand-Bold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("./fonts/Quicksand-Bold/fonts/Quicksand-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("./fonts/Quicksand-Bold/fonts/Quicksand-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("./fonts/Quicksand-Bold/fonts/Quicksand-Bold.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("./Assets/scheme_outline.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("./Assets/scheme_filled.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("./Assets/active.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("./Assets/view.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("./Assets/inactive.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("./Assets/edit.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("./Assets/delete.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Quicksand-Medium';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: local('☺'), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype'), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('svg');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'Quicksand';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  src: local('☺'), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('truetype'), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('svg');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'Quicksand-SemiBold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  src: local('☺'), url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('truetype'), url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format('svg');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'Quicksand-Bold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  src: local('☺'), url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format('truetype'), url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format('svg');
  font-weight: normal;
  font-style: normal;
}

body, div, a, h1, table, input, label, legend {
  font-family: 'Quicksand', sans-serif;
}

body {
  margin: 0;
  font-size: 0.875rem;
  font-family: 'Quicksand', sans-serif;
  line-height: 1.43;
  letter-spacing: 0;
}

/***************login*****************************/

input.MuiInputBase-input {
  font-family: "Quicksand-Medium";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 20px;
  color: #757575;
}

.MuiInputLabel-outlined.MuiInputLabel-shrink {
  font-size: 14px;
  font-family: "Quicksand-Medium";
}

.MuiFormHelperText-root.Mui-error {
  color: #E93529;
  font-family: "Quicksand";
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 15px;
}

.MuiFormHelperText-root.Mui-error {
  color: #E93529;
  margin-left: 0px;
}

.Mui-error span.error_message {
  display: flex;
  margin: 5px 0px 0px;
}

span.warn_message {
  color: "#c4c4c4";
  display: flex;
  margin: 5px 0px 0px;
}

.Mui-error svg {
  width: 16px;
  height: 16px;
  margin-right: 4px
}

button.password_icon.MuiIconButton-edgeEnd {
  color: #9E9E9E;
}

button.password_icon.MuiIconButton-edgeEnd svg {
  width: 24px;
  height: 24px;
}

.action_form .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
  border-color: #DADCE0;
}

.action_form .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline, .action_form .MuiOutlinedInput-root.Mui-error.Mui-focused .MuiOutlinedInput-notchedOutline {
  border-color: #E93529;
}

/* .action_form label.MuiInputLabel-outlined {
  color: #757575;
  font-family: "Quicksand";
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 20px;
} */

.action_form .MuiOutlinedInput-notchedOutline {
  border: 1px solid #DADCE0;
  border-radius: 4px;
}

.action_form .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
  border-width: 1px;
  border-color: #1BA785;
}

/**************list******************/

.item_list {
  display: flex;
  position: relative;
  box-sizing: border-box;
  text-align: left;
  align-items: center;
  justify-content: flex-start;
  text-decoration: none;
  border-left: solid 4px transparent;
}

.nav-item.MuiListItem-gutters.MuiListItem-button.active .item_list {
  border-left: solid 4px #1BA785;
}

.nav-item.active .item_list div {
  color: #1BA785;
}

.item_list div {
  color: #757575;
  font-family: "Quicksand-Medium";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 20px
}

.MuiListItem-button.item_a:hover {
  /* border-left:solid 4px transparent;
    background-color: rgba(0, 0, 0, 0.04); */
}

.filter_heading {
  color: #424242;
  font-family: "Quicksand-Medium";
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 30px;
  margin-top: -18px;
  padding: 0px 0px 20px;
}

.action_form label.MuiInputLabel-outlined {
  font-family: "Quicksand-Medium";
  font-size: 16px;
}

.action_form .MuiInputLabel-outlined.MuiInputLabel-shrink {
  font-family: "Quicksand-Medium";
  font-size: 14px;
}

.button_text_sec .clear_form, .button_text_sec .clear_form:hover {
  color: #1BA785;
  font-family: "Quicksand";
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 18px;
  background-color: transparent;
}

.button_text_sec .clear_form:hover {
  text-decoration: underline;
}

.remember_text.button_text_sec {
  color: #757575;
}

button.filter_btn, button.filter_btn:hover {
  color: #1BA785;
  font-family: "Quicksand-Bold";
  font-size: 14px;
  letter-spacing: 0;
  line-height: 18px;
  height: 38px;
  width: 108px;
  border: 1px solid #EEEEEE;
  border-radius: 2px;
  background-color: #FFFFFF;
  margin-right: 10px;
}

button.MuiButtonBase-root {
  text-transform: inherit;
}

button.MuiButton-textPrimary:hover {
  /* background-color:transparent; */
}

button.delete_all_btn svg {
  height: 20px;
  width: 20px;
  color: #1BA785;
}

button.delete_all_btn {
  height: 38px;
  width: 108px;
  border: 1px solid #EEEEEE;
  border-radius: 3px;
  background-color: #FFFFFF;
  color: #1BA785;
  font-family: "Quicksand-Bold";
  font-size: 14px;
  letter-spacing: 0;
  line-height: 18px;
}

.swipeableDrawer div {
  left: auto;
  right: -20px!important;
}

button.create_btn svg, button.filter_btn svg {
  widows: 16px;
  height: 16px;
}

button.create_btn, button.create_btn:hover {
  color: #FFFFFF;
  font-family: "Quicksand-Bold";
  font-size: 14px;
  letter-spacing: 0;
  line-height: 18px;
  text-align: center;
  height: 38px;
  width: 108px;
  border-radius: 3px;
  background-color: #1BA785;
}

.paper_box .arrowIcon {
  height: 16px;
  width: 16px;
}

.action_form .action_login_button:hover, .action_form .action_login_button {
  color: #FFFFFF;
  font-family: "Quicksand-Bold";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 20px;
  text-align: center;
  height: 48px;
  width: 120px;
  border-radius: 4px;
  background-color: #1BA785;
  margin: 10px 0px;
  text-transform: inherit;
  box-shadow: none;
}

.action_form .disabled_login_button {
  color: #ffffff !important;
  background-color: #d4d3d3 !important;
}

.login_content {
  color: #FFFFFF;
  font-family: "Quicksand-SemiBold";
  font-size: 20px;
  letter-spacing: 0;
  line-height: 30px;
}

.login_header h1 {
  color: #212121;
  font-family: "Quicksand-Medium";
  font-size: 32px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 34px;
}

.login_header p {
  color: #212121;
  font-family: "Quicksand-Medium";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 30px;
  padding-bottom: 6px;
}

.button_text_sec {
  display: flex;
}

.button_text_sec, .button_text_sec a {
  font-family: "Quicksand-Medium";
  font-size: 14px;
  letter-spacing: 0;
  line-height: 18px;
}

.delete_dialog .MuiDialog-paperWidthSm {
  background-color: #FFFFFF;
  box-shadow: -20px 0 40px 0 rgba(0, 0, 0, 0.1);
  width: 500px;
  border-radius: 0;
}

.close_dialog {
  cursor: pointer;
  position: absolute;
  right: 15px;
  top: 15px;
  width: 24px;
  height: 24px;
}

.cell_name:hover {
  color: #1BA785;
}

.delete_dialog .MuiDialogActions-root {
  justify-content: center;
  padding-bottom: 50px;
}

.delete_dialog .delete_dialog_title {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 0px 0px;
}

.badge {
  border-radius: 2px;
  font-family: "Quicksand-Bold";
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0;
  text-align: center;
  height: 20px;
  width: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.badge.badge-success {
  color: #36C14D;
  background-color: #E0FEE5
}

.badge.badge-danger {
  color: #E93529;
  background-color: #FFE6E4
}

.delete_dialog h2 {
  margin-bottom: 0;
  color: #424242;
  font-family: "Quicksand-SemiBold";
  font-size: 20px;
  letter-spacing: 0;
  line-height: 25px;
  text-align: center;
}

.delete_dialog p {
  color: #757575;
  font-family: "Quicksand-Medium";
  font-size: 16px;
  letter-spacing: 0;
  margin-top: 5px;
  line-height: 20px;
  text-align: center;
}

button.MuiButton-textPrimary.no {
  color: #1BA785;
  font-family: "Quicksand-Bold";
  font-size: 14px;
  letter-spacing: 0;
  line-height: 18px;
  text-align: center;
  height: 42px;
  width: 96px;
  border: 1px solid #EEEEEE;
  border-radius: 3px;
  background-color: #FFFFFF;
}

button.MuiButton-textPrimary.yes {
  height: 42px;
  width: 96px;
  border-radius: 3px;
  background-color: #1BA785;
  color: #FFFFFF;
  font-family: "Quicksand-Bold";
  font-size: 14px;
  letter-spacing: 0;
  line-height: 18px;
  text-align: center;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  display: none;
  float: left;
  min-width: 10rem;
  padding: 0.5rem 0;
  margin: 0.125rem 0 0;
  font-size: 1rem;
  color: #212529;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #e8ecf1;
  border-radius: 0.25rem;
}

.user_menu {
  margin: 0;
  width: 160px;
  box-sizing: border-box;
  border: 1px solid #E0E0E0;
  background-color: #FFFFFF;
  border-top: transparent;
  border-radius: 6px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1);
  padding: 12px 0px;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: 0.25rem 1.5rem;
  clear: both;
  font-weight: 400;
  color: #343a40;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  cursor: pointer;
}

.icon-options-vertical {
  cursor: pointer;
  height: 28px;
  color: #9E9E9E;
  width: 24px;
  text-align: center;
  margin-right: 20px;
}

.user_menu a {
  color: #212121;
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  letter-spacing: 0;
  line-height: 30px;
}

article .MuiTableRow-root.Mui-selected, article .MuiTableRow-root.Mui-selected:hover {
  background-color: transparent;
}

article .MuiPaper-root table tr th.selectedAll {
  padding: 0;
}

article .MuiPaper-root table tr td {
  padding: 17px 0px;
  letter-spacing: 0;
  color: #424242;
  font-family: "Quicksand-Medium";
  font-size: 14px;
  /* font-weight: 500; */
  letter-spacing: 0;
  line-height: 18px;
  max-width: 200px;
  line-break: anywhere;
}

article .MuiPaper-root table tr th {
  color: #424242;
  font-family: "Quicksand-Medium";
  font-size: 14px;
  /* font-weight: 500; */
  letter-spacing: 0;
  line-height: 18px;
  padding: 17px 0px;
  letter-spacing: 0;
}

article .MuiPaper-root table tr td .MuiCheckbox-colorSecondary, article .MuiPaper-root table tr th .MuiCheckbox-colorSecondary {
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  padding-left: 15px;
}

.view_header {
  color: #424242;
  font-family: "Quicksand";
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 30px;
  margin-bottom: 30px;
}

.step_header {
  color: #424242;
  font-family: "Quicksand";
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 30px;
  margin-bottom: 20px;
}

.MuiAutocomplete-popper {
  border: 1px solid #EEEEEE;
  box-shadow: 0 6px 12px 0 rgba(0, 0, 0, 0.08)!important;
}

.dropdown-item:hover, .dropdown-item:focus {
  color: #16181b;
  text-decoration: none;
  background-color: #fAfAfA;
}

.users_menu .dropdown-item {
  color: #757575;
  font-family: "Quicksand-Medium";
  font-size: 14px;
  letter-spacing: 0;
  line-height: 21px;
  display: flex;
  align-items: center;
  padding: 0.6rem 0.8rem;
}

.dropdown-menu.users_menu.active {
  display: block;
  width: 160px;
  padding: 0 0px;
  min-width: 160px;
  color: #212121;
  font-size: 12px;
  letter-spacing: 0;
  line-height: 30px;
}

.MuiTableRow-root.MuiTableRow-hover:hover {
  background-color: transparent !important;
}

.file_upload {
  border: 1px solid #DADCE0;
  border-radius: 4px;
  background-color: #FAFAFA;
  padding: 26px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.file_upload p {
  color: #757575;
  font-family: "Quicksand-Medium";
  font-size: 12px;
  letter-spacing: 0;
  line-height: 15px;
  text-align: center;
  padding: 0;
  margin: 15px 0px 0px;
}

.file_upload .contained_label {
  width: 100%;
  display: flex;
  align-items: center;justify-content:center;
}
.file_upload .contained_label .upload_button{
  color: #FFFFFF;
  font-family: "Quicksand-Bold";
  font-size: 14px; 
  letter-spacing: 0;
  line-height: 18px;
  text-align: center;
}
.file_upload .contained_label .upload_button.MuiButton-containedPrimary {
  color: #fff;
  background-color: #1BA785;
  height: 42px;
  width: 108px;
  border-radius: 3px;
  background-color: #1BA785;
}
.file_upload .head_text {
  color: #212121;
  font-family: "Quicksand-Medium";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 20px;
  text-align: center;
  padding-bottom: 15px;
}
.loading{
  position: absolute;
  background: #0000002e;
  width: 100%;
  height: 100%;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.upload_button {}

.MuiAutocomplete-listbox .MuiAutocomplete-option {
  padding: 16px 16px;
  color: #757575;
  font-family: "Quicksand-Medium";
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 18px;
}

.MuiAutocomplete-listbox .MuiAutocomplete-option span {
  padding: 0
}

.users_menu i {
  background-size: 20px 20px;
  width: 20px;
  height: 20px;
  color: rgba(0, 0, 0, 0.54);
  display: inline-flex;
  min-width: 20px;
  flex-shrink: 0;
  margin: 0px 10px 0px 0px;
}

.scheme_icon {
  background-size: 24px 24px;
  width: 24px;
  height: 24px;
  color: rgba(0, 0, 0, 0.54);
  display: inline-flex;
  min-width: 24px;
  flex-shrink: 0;
  margin: 0px 0px 0px 0px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
}

.active .scheme_icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
}

.active_icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
}

.view_icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
}

.Inactive_icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
}

.edit_icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
}

.delete_icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
}

.steper_wraper {
  width: 100%;
  padding-left: 3px;
  padding-right: 5px;
}

.steper_wraper input.MuiInputBase-input {
  background: #fff;
}

.steper_wraper .MuiStepper-horizontal {
  background-color: transparent;
  padding: 5px 10px 5px 10px;
  width: 100%;
  display: flex;
}

.cursorActive, .cursorActive div, .cursorActive span, .cursorActive img {
  cursor: pointer;
}

.steper_wraper .MuiStepLabel-label.MuiStepLabel-completed {
  font-weight: 500;
  color: #424242;
  font-family: "Quicksand";
  line-height: 15px;
  letter-spacing: 0;
}

.steper_wraper .MuiStepLabel-label {
  color: #9E9E9E;
  font-family: "Quicksand";
  font-size: 12px;
  letter-spacing: 0;
  line-height: 15px;
}

.steper_wraper .MuiStep-horizontal {
  padding-left: 0px;
  padding-right: 0px;
  width: 26%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  min-height: 35px;
}

.steper_wraper .MuiStep-horizontal:last-child {
  width: 130px;
  justify-content: flex-end;
}

.steper_wraper .progress_box {
  width: 100%
}

.steper_wraper .progress_box div {
  width: 100%;
}

.steper_wraper .MuiLinearProgress-root {
  height: 2px;
}

.steper_wraper .MuiLinearProgress-barColorPrimary {
  background-color: #424242;
}

.steper_wraper .MuiLinearProgress-colorPrimary {
  background-color: #eeeeee;
}

.steper_wraper .MuiStepLabel-iconContainer img {
  width: 14px;
  height: 14px;
}

.step_action {
  border: 1px solid #EEEEEE;
  border-radius: 0 0 4px 4px;
  background-color: #FFFFFF;
  box-shadow: 0 -4px 8px 0 rgba(0, 0, 0, 0.04);
  padding: 10px 40px;
}

.last_range_row div {
  text-align: right;
  padding: 4px 0px;
}

.deleteAccordRangeIcon {
  width: 100%;
  text-align: right;
  padding: 10px 10px;
}

.deleteAccordRangeIcon img {
  cursor: pointer;
}

.action_form .MuiOutlinedInput-notchedOutline {}

button.btn_addForm, button.btn_addForm:hover {
  color: #1BA785;
  font-family: "Quicksand";
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0;
  padding-left: 0;
  line-height: 15px;
  background-color: transparent;
}

button.btn_addForm svg, button.btn_addForm svg:hover {
  width: 16px;
  height: 16px;
  margin-right: 4px;
}

.action_form .MuiAccordion-root:before {
  background-color: transparent;
}

.steper_wraper .MuiAccordionSummary-root {
  padding: 0px 16px;
  min-height: 74px;
}

.steper_wraper .MuiAccordionSummary-root.Mui-expanded {
  min-height: 74px;
}

.DatePicker {
  width: 100%;
}

.steper_wraper .MuiAccordion-root.Mui-expanded {
  padding: 0px 14px;
}

.last_grid_row div {
  padding: 10px 25px 10px;
  text-align: right;
}

.deleteAccordIcon {
  position: absolute;
  right: 50px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 15px;
  height: 40px;
  width: 50px;
}

.paper_scroll {
  width: 100%;
  /* max-height: 500px;
  overflow-y: auto; */
}

/* Pagination */

.pagination {
  display: flex;
  padding-left: 0;
  justify-content: center;
  list-style: none;
  border-radius: 0.25rem;
  border-radius: 2px !important;
}

.page-item.next-arrow, .page-item.prev-arrow, .page-item.next-arrow:hover, .page-item.prev-arrow:hover {
  background-color: transparent;
  border: 1px solid transparent !important;
  text-decoration: none !important;
}

.page-item.next-arrow a, .page-item.prev-arrow a {}

.page-item.next-arrow i, .page-item.prev-arrow i {
  font-weight: 900;
}

.page-link {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #007bff;
  justify-content: center;
  align-items: center;
  display: flex;
  /* background-color: #fff;
    border: 1px solid #dee2e6; */
}

.page-link:hover {
  z-index: 2;
  color: #0056b3;
  text-decoration: none;
  background-color: #e9ecef;
  border-color: #dee2e6;
}

.page-link:focus {
  z-index: 2;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.page-item:first-child .page-link {
  margin-left: 0;
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}

.page-item:last-child .page-link {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}

.page-item.active .page-link {
  z-index: 1;
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
}

.page-item.disabled .page-link {
  color: #6c757d;
  pointer-events: none;
  cursor: auto;
  background-color: #fff;
  border-color: #dee2e6;
}

.pagination-lg .page-link {
  padding: 0.75rem 1.5rem;
  font-size: 1.25rem;
  line-height: 1.5;
}

.pagination-lg .page-item:first-child .page-link {
  border-top-left-radius: 0.3rem;
  border-bottom-left-radius: 0.3rem;
}

.pagination-lg .page-item:last-child .page-link {
  border-top-right-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem;
}

.pagination-sm .page-link {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
}

.pagination-sm .page-item:first-child .page-link {
  border-top-left-radius: 0.2rem;
  border-bottom-left-radius: 0.2rem;
}

.pagination-sm .page-item:last-child .page-link {
  border-top-right-radius: 0.2rem;
  border-bottom-right-radius: 0.2rem;
}

.pagination .page-item .page-link {
  color: #212121;
  font-family: Quicksand;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 18px;
  transition-duration: 0.3s;
  text-decoration: none;
  cursor: pointer;
}

.pagination .page-item .page-link:focus {
  background: inherit;
}

.MuiInputBase-root.Mui-disabled {
  color: rgba(0, 0, 0, 0.38);
  cursor: default;
  opacity: 1;
  background: #F5F5F5;
  cursor: not-allowed;
}

.pagination .page-item .page-link i:before {
  font-size: inherit;
  line-height: 1;
  vertical-align: middle;
}

.backArrow svg {
  color: #424242;
}

.view_form.action_form .MuiInputBase-input.Mui-disabled, .view_form.action_form .MuiInputBase-root.Mui-disabled {
  background-color: #fff;
}

.backArrow {
  top: 0px;
  position: fixed;
  z-index: 1202;
  background: #fff;
  width: 70px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

label.formRedio span.MuiFormControlLabel-label {
  color: #424242;
  font-family: "Quicksand-Medium";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 20px;
  font-weight: normal;
}

.formRedio .MuiRadio-root {
  color: #1BA785;
  width: 24px;
  height: 24px;
  margin-right: 6px;
}

label.formRedio.MuiFormControlLabel-root {
  margin-right: 30px
}

.action_form .MuiInputBase-input.Mui-disabled {
  opacity: 1;
  background: #F5F5F5;
  cursor: not-allowed;
}

.action_form .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline {
  border-color: #DADCE0;
}

.pagination .page-item.active .page-link, .pagination .page-item:hover .page-link, .pagination .page-item:focus .page-link, .pagination .page-item:active .page-link {
  background: #1BA785;
  border-color: #1BA785;
  color: #ffffff;
}

.pagination.flat .page-item .page-link {
  border: none;
  border-radius: 2px;
}

.pagination.separated .page-item {
  margin-left: 7px;
  margin-right: 7px;
  width: 32px;
  height: 32px;
  border: 1px solid transparent;
  border-radius: 100%;
  overflow: hidden;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pagination.separated .page-item:hover {
  border-color: #EEEEEE;
  background-color: #EEEEEE;
}

.pagination.separated .page-item:hover a, .pagination.separated .page-item:hover {
  background: none;
  color: #212121;
}

.pagination.separated .page-item .active:hover {}

.pagination.separated .page-item:first-child {
  margin-left: 0;
}

.pagination.separated .page-item:last-child {
  margin-right: 0;
}

/* .pagination.separated .page-item .page-link {
    border-radius: 2px;
  } */

.pagination.rounded .page-item:first-child .page-link, .pagination.loader-demo-box .page-item:first-child .page-link {
  border-radius: 25px 0 0 25px;
}

.pagination.rounded .page-item:last-child .page-link, .pagination.loader-demo-box .page-item:last-child .page-link {
  border-radius: 0 25px 25px 0;
}

.pagination.rounded-flat .page-item {
  margin-right: 3px;
  margin-left: 3px;
}

.pagination.rounded-flat .page-item .page-link {
  border: none;
  border-radius: 50px;
}

.pagination.rounded-separated .page-item {
  margin-left: 2px;
  margin-right: 2px;
}

.pagination.rounded-separated .page-item:first-child {
  margin-left: 0;
}

.pagination.rounded-separated .page-item:first-child .page-link {
  border-radius: 10px 0 0 10px;
}

.pagination.rounded-separated .page-item:last-child {
  margin-right: 0;
}

.pagination.rounded-separated .page-item:last-child .page-link {
  border-radius: 0 10px 10px 0;
}

.pagination.rounded-separated .page-item .page-link {
  border-radius: 2px;
}

/* pagination variations */

.pagination-primary .page-item.active .page-link {
  background: #3DB54A;
  border-color: #3DB54A;
}

.pagination-primary .page-item .page-link:hover {
  background: #2fe1e6;
  border-color: #3DB54A;
  color: #ffffff;
}

.pagination-secondary .page-item.active .page-link {
  background: #d8d8d8;
  border-color: #d8d8d8;
}

.pagination-secondary .page-item .page-link:hover {
  background: #e5e5e5;
  border-color: #d8d8d8;
  color: #ffffff;
}

.pagination-success .page-item.active .page-link {
  background: #38ce3c;
  border-color: #38ce3c;
}

.pagination-success .page-item .page-link:hover {
  background: #4cd350;
  border-color: #38ce3c;
  color: #ffffff;
}

.recon-pagination .text-muted {
  padding: 0px 20px;
}

.recon-pagination p {
  padding: 0px 5px;
}

.pagination-info .page-item.active, .pagination-info .page-item.active:hover {
  background: #3DB54A;
  border-color: #3DB54A;
  color: #ffffff;
}

.pagination-info .page-item.active a, .pagination-info .page-item.active:hover a {
  color: #ffffff;
}

.pagination-warning .page-item.active .page-link {
  background: #ffde73;
  border-color: #ffde73;
}

.pagination-warning .page-item .page-link:hover {
  background: #ffe48d;
  border-color: #ffde73;
  color: #ffffff;
}

.pagination-danger .page-item.active .page-link {
  background: #ff4d6b;
  border-color: #ff4d6b;
}

.pagination-danger .page-item .page-link:hover {
  background: #ff6780;
  border-color: #ff4d6b;
  color: #ffffff;
}

.pagination-light .page-item.active .page-link {
  background: #f8f9fa;
  border-color: #f8f9fa;
}

.pagination-light .page-item .page-link:hover {
  background: white;
  border-color: #f8f9fa;
  color: #ffffff;
}

.pagination-dark .page-item.active .page-link {
  background: #3e4b5b;
  border-color: #3e4b5b;
}

.pagination-dark .page-item .page-link:hover {
  background: #48586a;
  border-color: #3e4b5b;
  color: #ffffff;
}

/***************/

.login_form .email fieldset legend {
  width: 105px;
}

.forgot_form .forgot_email fieldset legend {
  width: 68px;
}

.filter_form .name_field fieldset legend {
  width: 92px;
}

.filter_form .id_field fieldset legend {
  width: 74px;
}

.filter_form .email_field fieldset legend {
  width: 91px;
}

.merchant_form {}

.merchant_form .name_field fieldset legend {
  width: 40px;
}

.merchant_form .id_field fieldset legend {
  width: 20px;
}

.merchant_form .email_field fieldset legend {
  width: 82px;
}

.merchant_form .status_field fieldset legend {
  width: 40px;
}

.merchant_form .multi_field fieldset legend {
  width: 67px;
}

.merchant_form .text_area_field fieldset legend {
  width: 82px;
}

.scheme_form .low_range_field fieldset legend {
  width: 65px;
}

.scheme_form .high_range_field fieldset legend {
  width: 68px;
}

.scheme_form .numberofInstallments_field fieldset legend {
  width: 127px;
}

.scheme_form .rateofInterest_field fieldset legend {
  width: 88px;
}

.scheme_form .feeofInstallments_field fieldset legend {
  width: 106px;
}

.scheme_form .cashbackType_field fieldset legend {
  width: 86px;
}

.scheme_form .issueCashbackValue_field fieldset legend {
  width: 168px;
}

.scheme_form .issueCashbackPercentage_field fieldset legend {
  width: 127px;
}

.scheme_form .totalCashbackPercentage_field fieldset legend {
  width: 148px;
}

.scheme_form .issueCashbackValue_field fieldset legend {
  width: 118px;
}

.scheme_form .totalCashbackValue_field fieldset legend {
  width: 118px;
}

.scheme_form .startDate_field fieldset legend {
  width: 62px;
}

.scheme_form .endDate_field fieldset legend {
  width: 56px
}

/*******daterpiker******/

.MuiInputLabel_shrink label {
  transform: translate(14px, -6px) scale(0.75);
}

.MuiInputLabel_shrink fieldset legend {
  max-width: 1000px;
  transition: max-width 100ms cubic-bezier(0.0, 0, 0.2, 1) 50ms;
}

.MuiAutocomplete-inputRoot .MuiChip-deletable .MuiChip-label {
  overflow: hidden;
  white-space: nowrap;
  padding-left: 12px;
  padding-right: 12px;
  text-overflow: ellipsis;
  font-family: "Quicksand-Medium";
  font-size: 12px;
  letter-spacing: 0;
  line-height: 20px;
  color: #424242;
}

svg.calender_input {
  color: #424242;
  width: 20px;
  height: 20px;
}

.tabs_wraper {
  padding-bottom: 20px;
}

.tabs_wraper .MuiTabs-flexContainer {
  border-bottom: solid 2px #E0E0E0;
}

.tabs_wraper .MuiTabs-flexContainer button span {
  color: #9E9E9E;
}

.tabs_wraper .MuiTabs-flexContainer button.Mui-selected span {
  color: #1BA785;
}

.tabs_wraper .MuiTabs-flexContainer button, .tabs_wraper .MuiTabs-flexContainer button span {
  /* color: #1BA785; */
  font-family: "Quicksand-Bold";
  font-size: 14px;
  letter-spacing: 0;
  line-height: 18px;
  text-transform: uppercase;
}

.mccCheckbox {
  display: inline-block !important
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield;
}

.MuiSelect-outlined.MuiSelect-outlined {
  padding-right: 32px;
  font-family: "Quicksand-Medium";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 20px;
  color: #757575;
}

.MuiMenu-list {
  outline: 0;
  font-family: "Quicksand-Medium";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 20px;
  color: #757575;
}

.action_form .MuiInputLabel-outlined {
  font-family: "Quicksand-Medium";
  font-size: 17px;
}

.action_form .MuiInputLabel-outlined.MuiInputLabel-shrink {
  font-family: "Quicksand-Medium";
  font-size: 17px;
}

.tabs_wraper .MuiTabs-flexContainer button span {}`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,4CAA+D;EAC/D,0LAAoP;EACpP,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,4CAAiE;EACjE,0LAA0P;EAC1P,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,4CAAmE;EACnE,4LAAgQ;EAChQ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,6CAA2D;EAC3D,6LAAwO;EACxO,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,oCAAoC;EACpC,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,kDAAkD;;AAElD;EACE,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;;;;;;GAOG;;AAEH;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA,qCAAqC;;AAErC;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;EAC3B,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;EACjB;AACF;;AAEA;EACE;4CAC0C;AAC5C;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,iCAAiC;EACjC,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,6CAA6C;EAC7C,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iCAAiC;EACjC,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,aAAa;EACb,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,0CAA0C;EAC1C,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iCAAiC;EACjC,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,sDAAsD;AACxD;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB,CAAC,sBAAsB;AAC5C;AACA;EACE,cAAc;EACd,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA,gBAAgB;;AAEhB;EACE,kBAAkB;EAClB,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE;AACF;;AAEA;EACE,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,0DAAkD;AACpD;;AAEA;EACE,0DAAiD;AACnD;;AAEA;EACE,0DAA0C;AAC5C;;AAEA;EACE,0DAAwC;AAC1C;;AAEA;EACE,0DAA4C;AAC9C;;AAEA;EACE,0DAAwC;AAC1C;;AAEA;EACE,0DAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,WAAW;EACX,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,wBAAwB;EACxB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,yBAAyB;EACzB,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA,+CAA+C;;AAE/C;EACE,cAAc;EACd,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX;qBACmB;AACrB;;AAEA,eAAe;;AAEf;EAGE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA,kDAAkD;;AAElD;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb;gCAC8B;AAChC;;AAEA;EACE,UAAU;EACV,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,UAAU;EAEV,gDAAgD;AAClD;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,YAAY;EACZ,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EAEjB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,UAAU;EACV,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,QAAQ;EACR,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE;AACF;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,gDAAgD;;AAEhD;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;;KAEK;;AAEL;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA,0BAA0B;;AAE1B;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,gBAAgB;;AAEhB;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA,gBAAgB;;AAEhB;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;AACF;;AAEA,wBAAwB;;AAExB;EACE,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,6DAA6D;AAC/D;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE;AACF;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA,iDAAiD","sourcesContent":["@font-face {\n  font-family: 'Quicksand-Medium';\n  src: url('./fonts/Quicksand-Medium/fonts/Quicksand-Medium.eot');\n  src: local('☺'), url('./fonts/Quicksand-Medium/fonts/Quicksand-Medium.woff') format('woff'), url('./fonts/Quicksand-Medium/fonts/Quicksand-Medium.ttf') format('truetype'), url('./fonts/Quicksand-Medium/fonts/Quicksand-Medium.svg') format('svg');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Quicksand';\n  src: url('./fonts/Quicksand-Regular/fonts/Quicksand-Regular.eot');\n  src: local('☺'), url('./fonts/Quicksand-Regular/fonts/Quicksand-Regular.woff') format('woff'), url('./fonts/Quicksand-Regular/fonts/Quicksand-Regular.ttf') format('truetype'), url('./fonts/Quicksand-Regular/fonts/Quicksand-Regular.svg') format('svg');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Quicksand-SemiBold';\n  src: url('./fonts/Quicksand-SemiBold/fonts/Quicksand-SemiBold.eot');\n  src: local('☺'), url('./fonts/Quicksand-SemiBold/fonts/Quicksand-SemiBold.woff') format('woff'), url('./fonts/Quicksand-SemiBold/fonts/Quicksand-SemiBold.ttf') format('truetype'), url('./fonts/Quicksand-SemiBold/fonts/Quicksand-SemiBold.svg') format('svg');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Quicksand-Bold';\n  src: url('./fonts/Quicksand-Bold/fonts/Quicksand-Bold.eot');\n  src: local('☺'), url('./fonts/Quicksand-Bold/fonts/Quicksand-Bold.woff') format('woff'), url('./fonts/Quicksand-Bold/fonts/Quicksand-Bold.ttf') format('truetype'), url('./fonts/Quicksand-Bold/fonts/Quicksand-Bold.svg') format('svg');\n  font-weight: normal;\n  font-style: normal;\n}\n\nbody, div, a, h1, table, input, label, legend {\n  font-family: 'Quicksand', sans-serif;\n}\n\nbody {\n  margin: 0;\n  font-size: 0.875rem;\n  font-family: 'Quicksand', sans-serif;\n  line-height: 1.43;\n  letter-spacing: 0;\n}\n\n/***************login*****************************/\n\ninput.MuiInputBase-input {\n  font-family: \"Quicksand-Medium\";\n  font-size: 16px;\n  letter-spacing: 0;\n  line-height: 20px;\n  color: #757575;\n}\n\n.MuiInputLabel-outlined.MuiInputLabel-shrink {\n  font-size: 14px;\n  font-family: \"Quicksand-Medium\";\n}\n\n.MuiFormHelperText-root.Mui-error {\n  color: #E93529;\n  font-family: \"Quicksand\";\n  font-size: 12px;\n  font-weight: 500;\n  letter-spacing: 0;\n  line-height: 15px;\n}\n\n.MuiFormHelperText-root.Mui-error {\n  color: #E93529;\n  margin-left: 0px;\n}\n\n.Mui-error span.error_message {\n  display: flex;\n  margin: 5px 0px 0px;\n}\n\nspan.warn_message {\n  color: \"#c4c4c4\";\n  display: flex;\n  margin: 5px 0px 0px;\n}\n\n.Mui-error svg {\n  width: 16px;\n  height: 16px;\n  margin-right: 4px\n}\n\nbutton.password_icon.MuiIconButton-edgeEnd {\n  color: #9E9E9E;\n}\n\nbutton.password_icon.MuiIconButton-edgeEnd svg {\n  width: 24px;\n  height: 24px;\n}\n\n.action_form .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {\n  border-color: #DADCE0;\n}\n\n.action_form .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline, .action_form .MuiOutlinedInput-root.Mui-error.Mui-focused .MuiOutlinedInput-notchedOutline {\n  border-color: #E93529;\n}\n\n/* .action_form label.MuiInputLabel-outlined {\n  color: #757575;\n  font-family: \"Quicksand\";\n  font-size: 16px;\n  font-weight: 500;\n  letter-spacing: 0;\n  line-height: 20px;\n} */\n\n.action_form .MuiOutlinedInput-notchedOutline {\n  border: 1px solid #DADCE0;\n  border-radius: 4px;\n}\n\n.action_form .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {\n  border-width: 1px;\n  border-color: #1BA785;\n}\n\n/**************list******************/\n\n.item_list {\n  display: flex;\n  position: relative;\n  box-sizing: border-box;\n  text-align: left;\n  align-items: center;\n  justify-content: flex-start;\n  text-decoration: none;\n  border-left: solid 4px transparent;\n}\n\n.nav-item.MuiListItem-gutters.MuiListItem-button.active .item_list {\n  border-left: solid 4px #1BA785;\n}\n\n.nav-item.active .item_list div {\n  color: #1BA785;\n}\n\n.item_list div {\n  color: #757575;\n  font-family: \"Quicksand-Medium\";\n  font-size: 16px;\n  letter-spacing: 0;\n  line-height: 20px\n}\n\n.MuiListItem-button.item_a:hover {\n  /* border-left:solid 4px transparent;\n    background-color: rgba(0, 0, 0, 0.04); */\n}\n\n.filter_heading {\n  color: #424242;\n  font-family: \"Quicksand-Medium\";\n  font-size: 24px;\n  font-weight: 500;\n  letter-spacing: 0;\n  line-height: 30px;\n  margin-top: -18px;\n  padding: 0px 0px 20px;\n}\n\n.action_form label.MuiInputLabel-outlined {\n  font-family: \"Quicksand-Medium\";\n  font-size: 16px;\n}\n\n.action_form .MuiInputLabel-outlined.MuiInputLabel-shrink {\n  font-family: \"Quicksand-Medium\";\n  font-size: 14px;\n}\n\n.button_text_sec .clear_form, .button_text_sec .clear_form:hover {\n  color: #1BA785;\n  font-family: \"Quicksand\";\n  font-size: 14px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 18px;\n  background-color: transparent;\n}\n\n.button_text_sec .clear_form:hover {\n  text-decoration: underline;\n}\n\n.remember_text.button_text_sec {\n  color: #757575;\n}\n\nbutton.filter_btn, button.filter_btn:hover {\n  color: #1BA785;\n  font-family: \"Quicksand-Bold\";\n  font-size: 14px;\n  letter-spacing: 0;\n  line-height: 18px;\n  height: 38px;\n  width: 108px;\n  border: 1px solid #EEEEEE;\n  border-radius: 2px;\n  background-color: #FFFFFF;\n  margin-right: 10px;\n}\n\nbutton.MuiButtonBase-root {\n  text-transform: inherit;\n}\n\nbutton.MuiButton-textPrimary:hover {\n  /* background-color:transparent; */\n}\n\nbutton.delete_all_btn svg {\n  height: 20px;\n  width: 20px;\n  color: #1BA785;\n}\n\nbutton.delete_all_btn {\n  height: 38px;\n  width: 108px;\n  border: 1px solid #EEEEEE;\n  border-radius: 3px;\n  background-color: #FFFFFF;\n  color: #1BA785;\n  font-family: \"Quicksand-Bold\";\n  font-size: 14px;\n  letter-spacing: 0;\n  line-height: 18px;\n}\n\n.swipeableDrawer div {\n  left: auto;\n  right: -20px!important;\n}\n\nbutton.create_btn svg, button.filter_btn svg {\n  widows: 16px;\n  height: 16px;\n}\n\nbutton.create_btn, button.create_btn:hover {\n  color: #FFFFFF;\n  font-family: \"Quicksand-Bold\";\n  font-size: 14px;\n  letter-spacing: 0;\n  line-height: 18px;\n  text-align: center;\n  height: 38px;\n  width: 108px;\n  border-radius: 3px;\n  background-color: #1BA785;\n}\n\n.paper_box .arrowIcon {\n  height: 16px;\n  width: 16px;\n}\n\n.action_form .action_login_button:hover, .action_form .action_login_button {\n  color: #FFFFFF;\n  font-family: \"Quicksand-Bold\";\n  font-size: 16px;\n  letter-spacing: 0;\n  line-height: 20px;\n  text-align: center;\n  height: 48px;\n  width: 120px;\n  border-radius: 4px;\n  background-color: #1BA785;\n  margin: 10px 0px;\n  text-transform: inherit;\n  box-shadow: none;\n}\n\n.action_form .disabled_login_button {\n  color: #ffffff !important;\n  background-color: #d4d3d3 !important;\n}\n\n.login_content {\n  color: #FFFFFF;\n  font-family: \"Quicksand-SemiBold\";\n  font-size: 20px;\n  letter-spacing: 0;\n  line-height: 30px;\n}\n\n.login_header h1 {\n  color: #212121;\n  font-family: \"Quicksand-Medium\";\n  font-size: 32px;\n  font-weight: 500;\n  letter-spacing: 0;\n  line-height: 34px;\n}\n\n.login_header p {\n  color: #212121;\n  font-family: \"Quicksand-Medium\";\n  font-size: 16px;\n  letter-spacing: 0;\n  line-height: 30px;\n  padding-bottom: 6px;\n}\n\n.button_text_sec {\n  display: flex;\n}\n\n.button_text_sec, .button_text_sec a {\n  font-family: \"Quicksand-Medium\";\n  font-size: 14px;\n  letter-spacing: 0;\n  line-height: 18px;\n}\n\n.delete_dialog .MuiDialog-paperWidthSm {\n  background-color: #FFFFFF;\n  box-shadow: -20px 0 40px 0 rgba(0, 0, 0, 0.1);\n  width: 500px;\n  border-radius: 0;\n}\n\n.close_dialog {\n  cursor: pointer;\n  position: absolute;\n  right: 15px;\n  top: 15px;\n  width: 24px;\n  height: 24px;\n}\n\n.cell_name:hover {\n  color: #1BA785;\n}\n\n.delete_dialog .MuiDialogActions-root {\n  justify-content: center;\n  padding-bottom: 50px;\n}\n\n.delete_dialog .delete_dialog_title {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 40px 0px 0px;\n}\n\n.badge {\n  border-radius: 2px;\n  font-family: \"Quicksand-Bold\";\n  font-size: 12px;\n  font-weight: bold;\n  letter-spacing: 0;\n  text-align: center;\n  height: 20px;\n  width: 60px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.badge.badge-success {\n  color: #36C14D;\n  background-color: #E0FEE5\n}\n\n.badge.badge-danger {\n  color: #E93529;\n  background-color: #FFE6E4\n}\n\n.delete_dialog h2 {\n  margin-bottom: 0;\n  color: #424242;\n  font-family: \"Quicksand-SemiBold\";\n  font-size: 20px;\n  letter-spacing: 0;\n  line-height: 25px;\n  text-align: center;\n}\n\n.delete_dialog p {\n  color: #757575;\n  font-family: \"Quicksand-Medium\";\n  font-size: 16px;\n  letter-spacing: 0;\n  margin-top: 5px;\n  line-height: 20px;\n  text-align: center;\n}\n\nbutton.MuiButton-textPrimary.no {\n  color: #1BA785;\n  font-family: \"Quicksand-Bold\";\n  font-size: 14px;\n  letter-spacing: 0;\n  line-height: 18px;\n  text-align: center;\n  height: 42px;\n  width: 96px;\n  border: 1px solid #EEEEEE;\n  border-radius: 3px;\n  background-color: #FFFFFF;\n}\n\nbutton.MuiButton-textPrimary.yes {\n  height: 42px;\n  width: 96px;\n  border-radius: 3px;\n  background-color: #1BA785;\n  color: #FFFFFF;\n  font-family: \"Quicksand-Bold\";\n  font-size: 14px;\n  letter-spacing: 0;\n  line-height: 18px;\n  text-align: center;\n}\n\n.dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 1000;\n  display: none;\n  float: left;\n  min-width: 10rem;\n  padding: 0.5rem 0;\n  margin: 0.125rem 0 0;\n  font-size: 1rem;\n  color: #212529;\n  text-align: left;\n  list-style: none;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #e8ecf1;\n  border-radius: 0.25rem;\n}\n\n.user_menu {\n  margin: 0;\n  width: 160px;\n  box-sizing: border-box;\n  border: 1px solid #E0E0E0;\n  background-color: #FFFFFF;\n  border-top: transparent;\n  border-radius: 6px;\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1);\n  padding: 12px 0px;\n}\n\n.dropdown-item {\n  display: block;\n  width: 100%;\n  padding: 0.25rem 1.5rem;\n  clear: both;\n  font-weight: 400;\n  color: #343a40;\n  text-align: inherit;\n  white-space: nowrap;\n  background-color: transparent;\n  border: 0;\n  cursor: pointer;\n}\n\n.icon-options-vertical {\n  cursor: pointer;\n  height: 28px;\n  color: #9E9E9E;\n  width: 24px;\n  text-align: center;\n  margin-right: 20px;\n}\n\n.user_menu a {\n  color: #212121;\n  font-family: 'Roboto', sans-serif;\n  font-size: 12px;\n  letter-spacing: 0;\n  line-height: 30px;\n}\n\narticle .MuiTableRow-root.Mui-selected, article .MuiTableRow-root.Mui-selected:hover {\n  background-color: transparent;\n}\n\narticle .MuiPaper-root table tr th.selectedAll {\n  padding: 0;\n}\n\narticle .MuiPaper-root table tr td {\n  padding: 17px 0px;\n  letter-spacing: 0;\n  color: #424242;\n  font-family: \"Quicksand-Medium\";\n  font-size: 14px;\n  /* font-weight: 500; */\n  letter-spacing: 0;\n  line-height: 18px;\n  max-width: 200px;\n  line-break: anywhere;\n}\n\narticle .MuiPaper-root table tr th {\n  color: #424242;\n  font-family: \"Quicksand-Medium\";\n  font-size: 14px;\n  /* font-weight: 500; */\n  letter-spacing: 0;\n  line-height: 18px;\n  padding: 17px 0px;\n  letter-spacing: 0;\n}\n\narticle .MuiPaper-root table tr td .MuiCheckbox-colorSecondary, article .MuiPaper-root table tr th .MuiCheckbox-colorSecondary {\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 60px;\n  padding-left: 15px;\n}\n\n.view_header {\n  color: #424242;\n  font-family: \"Quicksand\";\n  font-size: 24px;\n  font-weight: 500;\n  letter-spacing: 0;\n  line-height: 30px;\n  margin-bottom: 30px;\n}\n\n.step_header {\n  color: #424242;\n  font-family: \"Quicksand\";\n  font-size: 24px;\n  font-weight: 500;\n  letter-spacing: 0;\n  line-height: 30px;\n  margin-bottom: 20px;\n}\n\n.MuiAutocomplete-popper {\n  border: 1px solid #EEEEEE;\n  box-shadow: 0 6px 12px 0 rgba(0, 0, 0, 0.08)!important;\n}\n\n.dropdown-item:hover, .dropdown-item:focus {\n  color: #16181b;\n  text-decoration: none;\n  background-color: #fAfAfA;\n}\n\n.users_menu .dropdown-item {\n  color: #757575;\n  font-family: \"Quicksand-Medium\";\n  font-size: 14px;\n  letter-spacing: 0;\n  line-height: 21px;\n  display: flex;\n  align-items: center;\n  padding: 0.6rem 0.8rem;\n}\n\n.dropdown-menu.users_menu.active {\n  display: block;\n  width: 160px;\n  padding: 0 0px;\n  min-width: 160px;\n  color: #212121;\n  font-size: 12px;\n  letter-spacing: 0;\n  line-height: 30px;\n}\n\n.MuiTableRow-root.MuiTableRow-hover:hover {\n  background-color: transparent !important;\n}\n\n.file_upload {\n  border: 1px solid #DADCE0;\n  border-radius: 4px;\n  background-color: #FAFAFA;\n  padding: 26px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.file_upload p {\n  color: #757575;\n  font-family: \"Quicksand-Medium\";\n  font-size: 12px;\n  letter-spacing: 0;\n  line-height: 15px;\n  text-align: center;\n  padding: 0;\n  margin: 15px 0px 0px;\n}\n\n.file_upload .contained_label {\n  width: 100%;\n  display: flex;\n  align-items: center;justify-content:center;\n}\n.file_upload .contained_label .upload_button{\n  color: #FFFFFF;\n  font-family: \"Quicksand-Bold\";\n  font-size: 14px; \n  letter-spacing: 0;\n  line-height: 18px;\n  text-align: center;\n}\n.file_upload .contained_label .upload_button.MuiButton-containedPrimary {\n  color: #fff;\n  background-color: #1BA785;\n  height: 42px;\n  width: 108px;\n  border-radius: 3px;\n  background-color: #1BA785;\n}\n.file_upload .head_text {\n  color: #212121;\n  font-family: \"Quicksand-Medium\";\n  font-size: 16px;\n  letter-spacing: 0;\n  line-height: 20px;\n  text-align: center;\n  padding-bottom: 15px;\n}\n.loading{\n  position: absolute;\n  background: #0000002e;\n  width: 100%;\n  height: 100%;\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.upload_button {}\n\n.MuiAutocomplete-listbox .MuiAutocomplete-option {\n  padding: 16px 16px;\n  color: #757575;\n  font-family: \"Quicksand-Medium\";\n  font-size: 14px;\n  font-weight: 500;\n  letter-spacing: 0;\n  line-height: 18px;\n}\n\n.MuiAutocomplete-listbox .MuiAutocomplete-option span {\n  padding: 0\n}\n\n.users_menu i {\n  background-size: 20px 20px;\n  width: 20px;\n  height: 20px;\n  color: rgba(0, 0, 0, 0.54);\n  display: inline-flex;\n  min-width: 20px;\n  flex-shrink: 0;\n  margin: 0px 10px 0px 0px;\n}\n\n.scheme_icon {\n  background-size: 24px 24px;\n  width: 24px;\n  height: 24px;\n  color: rgba(0, 0, 0, 0.54);\n  display: inline-flex;\n  min-width: 24px;\n  flex-shrink: 0;\n  margin: 0px 0px 0px 0px;\n  background-image: url(./Assets/scheme_outline.svg);\n}\n\n.active .scheme_icon {\n  background-image: url(./Assets/scheme_filled.svg);\n}\n\n.active_icon {\n  background-image: url(./Assets/active.svg);\n}\n\n.view_icon {\n  background-image: url(./Assets/view.svg);\n}\n\n.Inactive_icon {\n  background-image: url(./Assets/inactive.svg);\n}\n\n.edit_icon {\n  background-image: url(./Assets/edit.svg);\n}\n\n.delete_icon {\n  background-image: url(./Assets/delete.svg);\n}\n\n.steper_wraper {\n  width: 100%;\n  padding-left: 3px;\n  padding-right: 5px;\n}\n\n.steper_wraper input.MuiInputBase-input {\n  background: #fff;\n}\n\n.steper_wraper .MuiStepper-horizontal {\n  background-color: transparent;\n  padding: 5px 10px 5px 10px;\n  width: 100%;\n  display: flex;\n}\n\n.cursorActive, .cursorActive div, .cursorActive span, .cursorActive img {\n  cursor: pointer;\n}\n\n.steper_wraper .MuiStepLabel-label.MuiStepLabel-completed {\n  font-weight: 500;\n  color: #424242;\n  font-family: \"Quicksand\";\n  line-height: 15px;\n  letter-spacing: 0;\n}\n\n.steper_wraper .MuiStepLabel-label {\n  color: #9E9E9E;\n  font-family: \"Quicksand\";\n  font-size: 12px;\n  letter-spacing: 0;\n  line-height: 15px;\n}\n\n.steper_wraper .MuiStep-horizontal {\n  padding-left: 0px;\n  padding-right: 0px;\n  width: 26%;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  min-height: 35px;\n}\n\n.steper_wraper .MuiStep-horizontal:last-child {\n  width: 130px;\n  justify-content: flex-end;\n}\n\n.steper_wraper .progress_box {\n  width: 100%\n}\n\n.steper_wraper .progress_box div {\n  width: 100%;\n}\n\n.steper_wraper .MuiLinearProgress-root {\n  height: 2px;\n}\n\n.steper_wraper .MuiLinearProgress-barColorPrimary {\n  background-color: #424242;\n}\n\n.steper_wraper .MuiLinearProgress-colorPrimary {\n  background-color: #eeeeee;\n}\n\n.steper_wraper .MuiStepLabel-iconContainer img {\n  width: 14px;\n  height: 14px;\n}\n\n.step_action {\n  border: 1px solid #EEEEEE;\n  border-radius: 0 0 4px 4px;\n  background-color: #FFFFFF;\n  box-shadow: 0 -4px 8px 0 rgba(0, 0, 0, 0.04);\n  padding: 10px 40px;\n}\n\n.last_range_row div {\n  text-align: right;\n  padding: 4px 0px;\n}\n\n.deleteAccordRangeIcon {\n  width: 100%;\n  text-align: right;\n  padding: 10px 10px;\n}\n\n.deleteAccordRangeIcon img {\n  cursor: pointer;\n}\n\n.action_form .MuiOutlinedInput-notchedOutline {}\n\nbutton.btn_addForm, button.btn_addForm:hover {\n  color: #1BA785;\n  font-family: \"Quicksand\";\n  font-size: 12px;\n  font-weight: bold;\n  letter-spacing: 0;\n  padding-left: 0;\n  line-height: 15px;\n  background-color: transparent;\n}\n\nbutton.btn_addForm svg, button.btn_addForm svg:hover {\n  width: 16px;\n  height: 16px;\n  margin-right: 4px;\n}\n\n.action_form .MuiAccordion-root:before {\n  background-color: transparent;\n}\n\n.steper_wraper .MuiAccordionSummary-root {\n  padding: 0px 16px;\n  min-height: 74px;\n}\n\n.steper_wraper .MuiAccordionSummary-root.Mui-expanded {\n  min-height: 74px;\n}\n\n.DatePicker {\n  width: 100%;\n}\n\n.steper_wraper .MuiAccordion-root.Mui-expanded {\n  padding: 0px 14px;\n}\n\n.last_grid_row div {\n  padding: 10px 25px 10px;\n  text-align: right;\n}\n\n.deleteAccordIcon {\n  position: absolute;\n  right: 50px;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  top: 15px;\n  height: 40px;\n  width: 50px;\n}\n\n.paper_scroll {\n  width: 100%;\n  /* max-height: 500px;\n  overflow-y: auto; */\n}\n\n/* Pagination */\n\n.pagination {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding-left: 0;\n  justify-content: center;\n  list-style: none;\n  border-radius: 0.25rem;\n  border-radius: 2px !important;\n}\n\n.page-item.next-arrow, .page-item.prev-arrow, .page-item.next-arrow:hover, .page-item.prev-arrow:hover {\n  background-color: transparent;\n  border: 1px solid transparent !important;\n  text-decoration: none !important;\n}\n\n.page-item.next-arrow a, .page-item.prev-arrow a {}\n\n.page-item.next-arrow i, .page-item.prev-arrow i {\n  font-weight: 900;\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: 0.5rem 0.75rem;\n  margin-left: -1px;\n  line-height: 1.25;\n  color: #007bff;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  /* background-color: #fff;\n    border: 1px solid #dee2e6; */\n}\n\n.page-link:hover {\n  z-index: 2;\n  color: #0056b3;\n  text-decoration: none;\n  background-color: #e9ecef;\n  border-color: #dee2e6;\n}\n\n.page-link:focus {\n  z-index: 2;\n  outline: 0;\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n\n.page-item:first-child .page-link {\n  margin-left: 0;\n  border-top-left-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n}\n\n.page-item:last-child .page-link {\n  border-top-right-radius: 0.25rem;\n  border-bottom-right-radius: 0.25rem;\n}\n\n.page-item.active .page-link {\n  z-index: 1;\n  color: #fff;\n  background-color: #007bff;\n  border-color: #007bff;\n}\n\n.page-item.disabled .page-link {\n  color: #6c757d;\n  pointer-events: none;\n  cursor: auto;\n  background-color: #fff;\n  border-color: #dee2e6;\n}\n\n.pagination-lg .page-link {\n  padding: 0.75rem 1.5rem;\n  font-size: 1.25rem;\n  line-height: 1.5;\n}\n\n.pagination-lg .page-item:first-child .page-link {\n  border-top-left-radius: 0.3rem;\n  border-bottom-left-radius: 0.3rem;\n}\n\n.pagination-lg .page-item:last-child .page-link {\n  border-top-right-radius: 0.3rem;\n  border-bottom-right-radius: 0.3rem;\n}\n\n.pagination-sm .page-link {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.875rem;\n  line-height: 1.5;\n}\n\n.pagination-sm .page-item:first-child .page-link {\n  border-top-left-radius: 0.2rem;\n  border-bottom-left-radius: 0.2rem;\n}\n\n.pagination-sm .page-item:last-child .page-link {\n  border-top-right-radius: 0.2rem;\n  border-bottom-right-radius: 0.2rem;\n}\n\n.pagination .page-item .page-link {\n  color: #212121;\n  font-family: Quicksand;\n  font-size: 14px;\n  letter-spacing: 0;\n  line-height: 18px;\n  -webkit-transition-duration: 0.3s;\n  transition-duration: 0.3s;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.pagination .page-item .page-link:focus {\n  background: inherit;\n}\n\n.MuiInputBase-root.Mui-disabled {\n  color: rgba(0, 0, 0, 0.38);\n  cursor: default;\n  opacity: 1;\n  background: #F5F5F5;\n  cursor: not-allowed;\n}\n\n.pagination .page-item .page-link i:before {\n  font-size: inherit;\n  line-height: 1;\n  vertical-align: middle;\n}\n\n.backArrow svg {\n  color: #424242;\n}\n\n.view_form.action_form .MuiInputBase-input.Mui-disabled, .view_form.action_form .MuiInputBase-root.Mui-disabled {\n  background-color: #fff;\n}\n\n.backArrow {\n  top: 0px;\n  position: fixed;\n  z-index: 1202;\n  background: #fff;\n  width: 70px;\n  height: 60px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\nlabel.formRedio span.MuiFormControlLabel-label {\n  color: #424242;\n  font-family: \"Quicksand-Medium\";\n  font-size: 16px;\n  letter-spacing: 0;\n  line-height: 20px;\n  font-weight: normal;\n}\n\n.formRedio .MuiRadio-root {\n  color: #1BA785;\n  width: 24px;\n  height: 24px;\n  margin-right: 6px;\n}\n\nlabel.formRedio.MuiFormControlLabel-root {\n  margin-right: 30px\n}\n\n.action_form .MuiInputBase-input.Mui-disabled {\n  opacity: 1;\n  background: #F5F5F5;\n  cursor: not-allowed;\n}\n\n.action_form .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline {\n  border-color: #DADCE0;\n}\n\n.pagination .page-item.active .page-link, .pagination .page-item:hover .page-link, .pagination .page-item:focus .page-link, .pagination .page-item:active .page-link {\n  background: #1BA785;\n  border-color: #1BA785;\n  color: #ffffff;\n}\n\n.pagination.flat .page-item .page-link {\n  border: none;\n  border-radius: 2px;\n}\n\n.pagination.separated .page-item {\n  margin-left: 7px;\n  margin-right: 7px;\n  width: 32px;\n  height: 32px;\n  border: 1px solid transparent;\n  border-radius: 100%;\n  overflow: hidden;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.pagination.separated .page-item:hover {\n  border-color: #EEEEEE;\n  background-color: #EEEEEE;\n}\n\n.pagination.separated .page-item:hover a, .pagination.separated .page-item:hover {\n  background: none;\n  color: #212121;\n}\n\n.pagination.separated .page-item .active:hover {}\n\n.pagination.separated .page-item:first-child {\n  margin-left: 0;\n}\n\n.pagination.separated .page-item:last-child {\n  margin-right: 0;\n}\n\n/* .pagination.separated .page-item .page-link {\n    border-radius: 2px;\n  } */\n\n.pagination.rounded .page-item:first-child .page-link, .pagination.loader-demo-box .page-item:first-child .page-link {\n  border-radius: 25px 0 0 25px;\n}\n\n.pagination.rounded .page-item:last-child .page-link, .pagination.loader-demo-box .page-item:last-child .page-link {\n  border-radius: 0 25px 25px 0;\n}\n\n.pagination.rounded-flat .page-item {\n  margin-right: 3px;\n  margin-left: 3px;\n}\n\n.pagination.rounded-flat .page-item .page-link {\n  border: none;\n  border-radius: 50px;\n}\n\n.pagination.rounded-separated .page-item {\n  margin-left: 2px;\n  margin-right: 2px;\n}\n\n.pagination.rounded-separated .page-item:first-child {\n  margin-left: 0;\n}\n\n.pagination.rounded-separated .page-item:first-child .page-link {\n  border-radius: 10px 0 0 10px;\n}\n\n.pagination.rounded-separated .page-item:last-child {\n  margin-right: 0;\n}\n\n.pagination.rounded-separated .page-item:last-child .page-link {\n  border-radius: 0 10px 10px 0;\n}\n\n.pagination.rounded-separated .page-item .page-link {\n  border-radius: 2px;\n}\n\n/* pagination variations */\n\n.pagination-primary .page-item.active .page-link {\n  background: #3DB54A;\n  border-color: #3DB54A;\n}\n\n.pagination-primary .page-item .page-link:hover {\n  background: #2fe1e6;\n  border-color: #3DB54A;\n  color: #ffffff;\n}\n\n.pagination-secondary .page-item.active .page-link {\n  background: #d8d8d8;\n  border-color: #d8d8d8;\n}\n\n.pagination-secondary .page-item .page-link:hover {\n  background: #e5e5e5;\n  border-color: #d8d8d8;\n  color: #ffffff;\n}\n\n.pagination-success .page-item.active .page-link {\n  background: #38ce3c;\n  border-color: #38ce3c;\n}\n\n.pagination-success .page-item .page-link:hover {\n  background: #4cd350;\n  border-color: #38ce3c;\n  color: #ffffff;\n}\n\n.recon-pagination .text-muted {\n  padding: 0px 20px;\n}\n\n.recon-pagination p {\n  padding: 0px 5px;\n}\n\n.pagination-info .page-item.active, .pagination-info .page-item.active:hover {\n  background: #3DB54A;\n  border-color: #3DB54A;\n  color: #ffffff;\n}\n\n.pagination-info .page-item.active a, .pagination-info .page-item.active:hover a {\n  color: #ffffff;\n}\n\n.pagination-warning .page-item.active .page-link {\n  background: #ffde73;\n  border-color: #ffde73;\n}\n\n.pagination-warning .page-item .page-link:hover {\n  background: #ffe48d;\n  border-color: #ffde73;\n  color: #ffffff;\n}\n\n.pagination-danger .page-item.active .page-link {\n  background: #ff4d6b;\n  border-color: #ff4d6b;\n}\n\n.pagination-danger .page-item .page-link:hover {\n  background: #ff6780;\n  border-color: #ff4d6b;\n  color: #ffffff;\n}\n\n.pagination-light .page-item.active .page-link {\n  background: #f8f9fa;\n  border-color: #f8f9fa;\n}\n\n.pagination-light .page-item .page-link:hover {\n  background: white;\n  border-color: #f8f9fa;\n  color: #ffffff;\n}\n\n.pagination-dark .page-item.active .page-link {\n  background: #3e4b5b;\n  border-color: #3e4b5b;\n}\n\n.pagination-dark .page-item .page-link:hover {\n  background: #48586a;\n  border-color: #3e4b5b;\n  color: #ffffff;\n}\n\n/***************/\n\n.login_form .email fieldset legend {\n  width: 105px;\n}\n\n.forgot_form .forgot_email fieldset legend {\n  width: 68px;\n}\n\n.filter_form .name_field fieldset legend {\n  width: 92px;\n}\n\n.filter_form .id_field fieldset legend {\n  width: 74px;\n}\n\n.filter_form .email_field fieldset legend {\n  width: 91px;\n}\n\n.merchant_form {}\n\n.merchant_form .name_field fieldset legend {\n  width: 40px;\n}\n\n.merchant_form .id_field fieldset legend {\n  width: 20px;\n}\n\n.merchant_form .email_field fieldset legend {\n  width: 82px;\n}\n\n.merchant_form .status_field fieldset legend {\n  width: 40px;\n}\n\n.merchant_form .multi_field fieldset legend {\n  width: 67px;\n}\n\n.merchant_form .text_area_field fieldset legend {\n  width: 82px;\n}\n\n.scheme_form .low_range_field fieldset legend {\n  width: 65px;\n}\n\n.scheme_form .high_range_field fieldset legend {\n  width: 68px;\n}\n\n.scheme_form .numberofInstallments_field fieldset legend {\n  width: 127px;\n}\n\n.scheme_form .rateofInterest_field fieldset legend {\n  width: 88px;\n}\n\n.scheme_form .feeofInstallments_field fieldset legend {\n  width: 106px;\n}\n\n.scheme_form .cashbackType_field fieldset legend {\n  width: 86px;\n}\n\n.scheme_form .issueCashbackValue_field fieldset legend {\n  width: 168px;\n}\n\n.scheme_form .issueCashbackPercentage_field fieldset legend {\n  width: 127px;\n}\n\n.scheme_form .totalCashbackPercentage_field fieldset legend {\n  width: 148px;\n}\n\n.scheme_form .issueCashbackValue_field fieldset legend {\n  width: 118px;\n}\n\n.scheme_form .totalCashbackValue_field fieldset legend {\n  width: 118px;\n}\n\n.scheme_form .startDate_field fieldset legend {\n  width: 62px;\n}\n\n.scheme_form .endDate_field fieldset legend {\n  width: 56px\n}\n\n/*******daterpiker******/\n\n.MuiInputLabel_shrink label {\n  transform: translate(14px, -6px) scale(0.75);\n}\n\n.MuiInputLabel_shrink fieldset legend {\n  max-width: 1000px;\n  transition: max-width 100ms cubic-bezier(0.0, 0, 0.2, 1) 50ms;\n}\n\n.MuiAutocomplete-inputRoot .MuiChip-deletable .MuiChip-label {\n  overflow: hidden;\n  white-space: nowrap;\n  padding-left: 12px;\n  padding-right: 12px;\n  text-overflow: ellipsis;\n  font-family: \"Quicksand-Medium\";\n  font-size: 12px;\n  letter-spacing: 0;\n  line-height: 20px;\n  color: #424242;\n}\n\nsvg.calender_input {\n  color: #424242;\n  width: 20px;\n  height: 20px;\n}\n\n.tabs_wraper {\n  padding-bottom: 20px;\n}\n\n.tabs_wraper .MuiTabs-flexContainer {\n  border-bottom: solid 2px #E0E0E0;\n}\n\n.tabs_wraper .MuiTabs-flexContainer button span {\n  color: #9E9E9E;\n}\n\n.tabs_wraper .MuiTabs-flexContainer button.Mui-selected span {\n  color: #1BA785;\n}\n\n.tabs_wraper .MuiTabs-flexContainer button, .tabs_wraper .MuiTabs-flexContainer button span {\n  /* color: #1BA785; */\n  font-family: \"Quicksand-Bold\";\n  font-size: 14px;\n  letter-spacing: 0;\n  line-height: 18px;\n  text-transform: uppercase;\n}\n\n.mccCheckbox {\n  display: inline-block !important\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\ninput[type=number] {\n  -moz-appearance: textfield;\n}\n\n.MuiSelect-outlined.MuiSelect-outlined {\n  padding-right: 32px;\n  font-family: \"Quicksand-Medium\";\n  font-size: 16px;\n  letter-spacing: 0;\n  line-height: 20px;\n  color: #757575;\n}\n\n.MuiMenu-list {\n  outline: 0;\n  font-family: \"Quicksand-Medium\";\n  font-size: 16px;\n  letter-spacing: 0;\n  line-height: 20px;\n  color: #757575;\n}\n\n.action_form .MuiInputLabel-outlined {\n  font-family: \"Quicksand-Medium\";\n  font-size: 17px;\n}\n\n.action_form .MuiInputLabel-outlined.MuiInputLabel-shrink {\n  font-family: \"Quicksand-Medium\";\n  font-size: 17px;\n}\n\n.tabs_wraper .MuiTabs-flexContainer button span {}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
